import React, { Fragment, useEffect, useState } from "react";
import LinkIcon from "../../../../images/link.svg";
import DebugIcon from  "../../../../images/debug.svg";
import ErrorsIcon from "../../../../images/errors.svg";
import LoadingIcon from "../../../../images/ripple.gif";
import QAResultModal from "./QAResultModal";

const titleStyle = {
  height: "40px", 
  fontSize: "18px", 
  overflow: "hidden", 
  textOverflow: "ellipsis", 
}

const GoogleWebStoryViewer = ({userPost, showDebugLink, frameRenderable }) => {
  const [qaResultModalOpen, setQAResultModalOpen] = useState(false);

  const link = window.location.origin + LinkIcon;
  const debug = window.location.origin + DebugIcon;
  const errors = window.location.origin + ErrorsIcon;
  const last_qa_result = userPost.last_qa_result
  const showQAResult = !(userPost.hide_qa_result || false) && last_qa_result
  const portraitImage = last_qa_result && last_qa_result.elements && last_qa_result.elements['amp-story-poster-portrait-src']

  if(!userPost.frame_renderable && !frameRenderable) {
    const style = { width: "100%", height: "100%", padding: "20px", position: "absolute", left: 0, backgroundColor: "lightgray" }
    if(portraitImage) {
      Object.assign(style, { 
        backgroundColor: 'black',
        backgroundImage: `url(${last_qa_result.elements['amp-story-poster-portrait-src']})`,
        backgroundSize: 'auto 100%',
        backgroundRepeat: 'no-repeat', 
        backgroundPosition: 'center' })
    } 
    
    return <Fragment>
      <h3 style={titleStyle}>{userPost.title ? userPost.title : ''}</h3>
      <div className='media-container'>
        <div style={style}>
          <div style={{display: "flex", justifyContent: "space-between", width: "50%"}}>
            <a href={userPost.url} target='_blank'><img height="25px" src={link}/></a>
            { showDebugLink && <a href={`${userPost.url}#development=1`} target='_blank'><img height="25px" src={debug}/></a> }
            { showQAResult && <a onClick={ () => setQAResultModalOpen(true) } ><img height="25px" src={errors}/></a> }
          </div>
          {!portraitImage && <h4> We cannot render this story. <a href={userPost.url} target='_blank'>click here</a> to open it.</h4>}
        </div>
        { showQAResult &&
          <QAResultModal open={qaResultModalOpen} onCloseModal={() => setQAResultModalOpen(false)} result={last_qa_result}/> }
      </div>
    </Fragment>
  }

  useEffect(() => {

    const player = document.body.querySelector(`#amp-story-player-${userPost.id}`);

    if (!player) return;

    // Listen to when the specified control was clicked.
    player.addEventListener("amp-story-player-web-story-link", () => {
      // This will trigger when the control with the "custom-control" name is clicked.
      window.open(userPost.url, '_blank');
    });

    if(showDebugLink) {
      player.addEventListener("amp-story-player-web-story-debug-link", () => {
        window.open(`${userPost.url}#development=1`, '_blank');
      });
    }

    player.addEventListener("amp-story-player-show-errors", () => {
      setQAResultModalOpen(true);
    });

    const elements = document.querySelectorAll("span.linkify");
    elements.forEach(function(el) {
      el.innerHTML = linkifyHtml(el.innerHTML)
    });
  }, []);

  const controls = {"controls": [
    {"name": "share", "visibility": "hidden"},
    {"name": "next-container", "visibility": "hidden"},
    {"name": "web-story-link", "position": "start", "backgroundImageUrl": link },
  ]};

  if(showDebugLink) {
    controls["controls"].push({"name": "web-story-debug-link", "position": "start", "backgroundImageUrl": debug})
  }

  if(showQAResult) {
    controls["controls"].push({"name": "show-errors", "position": "start", "backgroundImageUrl": errors })
  }

  return <Fragment>
    <h3 style={titleStyle}>{userPost.title ? userPost.title : ''}</h3>
    <div className='media-container'>
      <amp-story-player id={`amp-story-player-${userPost.id}`} layout='fill' style={{width: "100%", height: "100%", position: 'absolute', left: 0}}>
          <script type="application/json" dangerouslySetInnerHTML={{ __html: JSON.stringify(controls) }} />
          <a href={userPost.url}>
            <img src={LoadingIcon} style={{width: "50px", position: 'absolute', left: "50%", marginLeft: "-25px", top: "50%", marginTop: "-25px"}} loading="lazy" data-amp-story-player-poster-img />
          </a>
      </amp-story-player>
      {showQAResult &&
        <QAResultModal open={qaResultModalOpen} onCloseModal={() => setQAResultModalOpen(false)} result={last_qa_result}/>}
    </div>
  </Fragment>
}

GoogleWebStoryViewer.defaultProps = {
  frameRenderable: false
};

export default GoogleWebStoryViewer;
